import React from "react";
import { aboutMe, highlights, skills } from "../data/mock";
import { useReveal } from "../hooks/useReveal";

const SectionHeading = ({ num, title }) => (
  <div className="flex items-center gap-4 mb-12 md:mb-16">
    <h2 className="flex items-baseline gap-3 whitespace-nowrap">
      <span className="font-mono text-accent text-lg md:text-xl">{num}.</span>
      <span className="font-sans text-2xl md:text-3xl font-semibold text-ink tracking-tight">
        {title}
      </span>
    </h2>
    <span className="hidden sm:block h-px flex-1 bg-rule" />
  </div>
);

const About = () => {
  const revealRef = useReveal();
  const stackPreview = [
    ...skills.languages.slice(0, 3),
    ...skills.databases.slice(0, 2),
    ...skills.messageQueue.slice(0, 2),
    ...skills.devops.slice(0, 3)
  ];

  return (
    <div className="py-24 md:py-32">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div ref={revealRef} className="reveal">
          <SectionHeading num="01" title="About" />

          <div className="grid grid-cols-1 lg:grid-cols-[1fr_320px] gap-12 lg:gap-16">
            <div className="space-y-5 text-[15px] md:text-base leading-relaxed text-ink-2 max-w-2xl">
              <p>{aboutMe.intro}</p>
              <p>{aboutMe.approach}</p>
              <p>
                A quick sample of what I reach for day-to-day — the full stack is under{" "}
                <a href="#skills" className="link-underline">Stack</a>.
              </p>
            </div>

            <div>
              <p className="font-mono text-xs uppercase tracking-widest text-ink-3 mb-4">
                // core stack
              </p>
              <ul className="grid grid-cols-2 gap-y-2 gap-x-4">
                {stackPreview.map((s) => (
                  <li key={s} className="flex items-center gap-2 text-sm text-ink-2">
                    <span className="text-accent font-mono text-xs">▸</span>
                    {s}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Highlights */}
          <div className="mt-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {highlights.map((h, i) => {
              const Icon = h.icon;
              return (
                <div
                  key={i}
                  className="card-lift p-5 rounded-lg border border-rule bg-bg-elev"
                >
                  <div className="flex items-center justify-between mb-6">
                    <Icon className="w-4 h-4 text-accent" strokeWidth={1.5} />
                    <span className="font-mono text-[11px] text-ink-3">
                      0{i + 1}
                    </span>
                  </div>
                  <h3 className="text-ink font-medium text-base mb-1.5">{h.title}</h3>
                  <p className="text-ink-2 text-sm leading-relaxed">{h.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
